export interface Interval {
  start: number;
  end: number;
}

export interface DaySchedule {
  day: number;
  intervals: Interval[];
}

export interface SchedulerValue {
  schedule: DaySchedule[];
  permission: GzSchedulerPermission;
}

export enum GzSchedulerPermission {
  BLOCK_ALL = 1,
  CUSTOM = 2,
  ALLOW_ALL = 3,
}
